module.exports = __webpack_public_path__ + "docs/assets/fonts/Roboto-Light-881e150ab929e26d1f812c4342c15a7c.ttf";